import React from 'react';
import noop from 'lodash/noop';

import { IntegrationSlot } from '../integrations-list/integration-slot';
import { getIntegrationSubtitle } from '../integrations-utils';

export type DefaultIntegrationProps = {
    id: string
    title: string
    image?: string
    icon?: JSX.Element
    testId?: string
    dataAppcuesId?: string;
}

type IntegrationProps = DefaultIntegrationProps & {
  isDisabled: boolean
  isSignInIntegration?: boolean
  onClick?: Function
}

export const createDefaultIntegration = ({
    id,
    title,
    isDisabled,
    isSignInIntegration = false,
    image = null,
    icon = null,
    testId = 'default-integration',
    onClick = noop,
    dataAppcuesId,
}: IntegrationProps) => ({
    id,
    Component: ({
        isIntegrated,
        ...props
    }: { isIntegrated: boolean }) => (
        <IntegrationSlot
            title={title}
            isDisabled={isDisabled}
            image={image}
            icon={icon}
            dataAppcuesId={dataAppcuesId}
            testId={testId}
            onClick={onClick}
            isIntegrated={isIntegrated}
            subtitle={getIntegrationSubtitle({ isDisabled, isSignInIntegration, isIntegrated })}
            {...props}
        />
    ),
});
